import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import ModalBase from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";

import Close from "core/ReusableIcons/Close";
import TruncateText from "core/TruncateText";
import Heading from "core/Heading";
import SrOnly from "core/SrOnly";
import BodyText from "core/BodyText";
import {
    HeadingFlexbox,
    ModalContent,
    ModalFooter,
    Paper,
    CloseButton,
    modalStyles
} from "./styles";

import { modalTypes } from "core/props";

const UnstyledModal = ({
    open,
    handleClose,
    heading,
    type = "text",
    footerChildren,
    className,
    children,
    ...otherProps
}) => {
    const closeButtonText = `Close the ${heading} modal window`;

    return (
        <ModalBase
            className={className}
            open={open}
            BackdropComponent={Backdrop}
            closeAfterTransition
            {...otherProps}
        >
            <Fade in={open}>
                <Paper type={type} footerChildren={footerChildren}>
                    <HeadingFlexbox justifyContent="space-between">
                        <Heading type="div" size="xs">
                            <TruncateText charLimit={50}>
                                {heading}
                            </TruncateText>
                        </Heading>

                        <CloseButton onClick={handleClose}>
                            <SrOnly>{closeButtonText}</SrOnly>
                            <Close
                                size={type === "fullScreen" ? "lg" : "sm"}
                                focusable={false}
                            />
                        </CloseButton>
                    </HeadingFlexbox>

                    <ModalContent>
                        {type === "text" || type === "kits" ? (
                            <BodyText type="div" size="lg">
                                {children}
                            </BodyText>
                        ) : (
                            children
                        )}
                    </ModalContent>

                    {!!footerChildren && type !== "fullScreen" && (
                        <ModalFooter>{footerChildren}</ModalFooter>
                    )}
                </Paper>
            </Fade>
        </ModalBase>
    );
};

UnstyledModal.propTypes = {
    className: PropTypes.string,
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    heading: PropTypes.string.isRequired,
    type: PropTypes.oneOf(modalTypes),
    footerChildren: PropTypes.any
};

const Modal = styled(UnstyledModal)`
    ${modalStyles}
`;

export default Modal;
